/**
 * CONSOLE
 * Define a stub console implementation if not exists (for IE) to prevent crashes about logs.
 */
window.console = window.console || (function(){
  var c = {}; c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function(s){};
  return c;
})();

/**
 * FILTER
 * Array filter implementation for old browser.
 */
if (!Array.prototype.filter) {

    Array.prototype.filter = function(fun /*, thisp */) {
      "use strict";

      if (this === void 0 || this === null) {
        throw new TypeError();
      }

      var t = Object(this);
      var len = t.length >>> 0;
      if (typeof fun !== "function")
        throw new TypeError();

      var res = [];
      var thisp = arguments[1];
      for (var i = 0; i < len; i++) {
        if (i in t) {
          var val = t[i]; // in case fun mutates this
          if (fun.call(thisp, val, i, t)) {
            res.push(val);
          }
        }
      }

      return res;
    };
}

(function() {
  $(document).ready(function() {
    $(document).ajaxError(function (event, jqXHR) {
      if (403 === jqXHR.status) {
         window.location.reload();
      }
    });
  });
})(jQuery);
